module.exports = {render: function () {with(this){return _c('svg',{attrs:{"fill":"#FFF","xmlns":"http://www.w3.org/2000/svg","data-name":"Layer 1","viewBox":"0 0 100 100"}},[_c('title',[_v("BasicUI")]),_c('path',{attrs:{"d":"M37.78 59.94c8.63 0 15.63-10.89 15.63-19.52a15.63 15.63 0 0 0-31.25 0c-.01 8.58 6.99 19.52 15.62 19.52z"}}),_c('path',{attrs:{"d":"M52.2 56h-.8c-3.78 4.86-8.6 7.54-13.62 7.54S27.95 60.91 24.16 56h-.8A18.36 18.36 0 0 0 5 74.4v11.34h65.56V74.4A18.36 18.36 0 0 0 52.2 56zM82.21 27.05V14.26H71.57v12.79H58.78v10.64h12.79v12.79h10.64V37.69H95V27.05H82.21z"}})])}}};


//////////////////
// WEBPACK FOOTER
// ./src/assets/noun_1159093_FFFFFF.svg
// module id = 7dQt
// module chunks = 0